import { Injectable } from '@angular/core';
import { InputMetadata, InputPasteEvent } from '@reflact/ipkv-types';

@Injectable({
  providedIn: 'root'
})
export class PasteTrackingService {
  private pasteEvents: InputPasteEvent[] = [];
  private _totalKeystrokes = 0;
  private _totalPastedChars = 0;
  private lastSentEventCount = 0;
  private lastSentKeystrokes = 0;
  private lastSentPastedChars = 0;

  public trackPaste(event: ClipboardEvent, source: "chat" | "table") {
    const pastedText = event.clipboardData?.getData('text') ?? '';
    if (pastedText.length === 0) return;

    this._totalPastedChars += pastedText.length;
    this.pasteEvents.push({
      timestamp: new Date().toISOString(),
      pastedTextLength: pastedText.length,
      totalInputLength: this._totalPastedChars + this._totalKeystrokes,
      source,
    });
  }

  public trackKeystroke() {
    this._totalKeystrokes++;
  }

  public getMetadata(): InputMetadata {
    return {
      pasteEvents: this.pasteEvents,
      totalKeystrokes: this._totalKeystrokes,
      totalPastedChars: this._totalPastedChars,
    };
  }

  public getAndResetDelta(): InputMetadata {
    const delta: InputMetadata = {
      pasteEvents: this.pasteEvents.slice(this.lastSentEventCount),
      totalKeystrokes: this._totalKeystrokes - this.lastSentKeystrokes,
      totalPastedChars: this._totalPastedChars - this.lastSentPastedChars,
    };
    this.lastSentEventCount = this.pasteEvents.length;
    this.lastSentKeystrokes = this._totalKeystrokes;
    this.lastSentPastedChars = this._totalPastedChars;
    return delta;
  }
}
